import { render, staticRenderFns } from "./oauth_callback.vue?vue&type=template&id=3533d1a4&scoped=true"
import script from "./oauth_callback.js?vue&type=script&lang=js&external"
export * from "./oauth_callback.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3533d1a4",
  null
  
)

export default component.exports